var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 19.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    fill: "none",
    d: "M19.71,20h0a3.48,3.48,0,0,0,2.54-1.13,4,4,0,0,0,1.07-2.75,3.76,3.76,0,0,0-3.62-3.86h0a3.45,3.45,0,0,0-2.54,1.13,4,4,0,0,0-1.07,2.75A3.76,3.76,0,0,0,19.71,20Z",
    transform: "translate(-2.74 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    fill: "none",
    d: "M11.68,15.21a2.57,2.57,0,0,0-.7-1.76,2.18,2.18,0,0,0-1.61-.71h0a2.25,2.25,0,0,0-1.61.72,2.59,2.59,0,0,0,0,3.51,2.2,2.2,0,0,0,1.61.71h0A2.18,2.18,0,0,0,11,17,2.53,2.53,0,0,0,11.68,15.21Z",
    transform: "translate(-2.74 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M10.18,18.8a3.38,3.38,0,0,0,1.71-1,3.84,3.84,0,0,0,0-5.21,3.41,3.41,0,0,0-2.5-1.09h0a3.43,3.43,0,0,0-2.5,1.11,3.81,3.81,0,0,0,0,5.2,3.44,3.44,0,0,0,1.68,1l.41.08-.41-.08C5.93,19.08,4.07,21,3,24.53l-.25.8,7.79,0a7.61,7.61,0,0,1,1-1.23l-7,0C5.46,21.34,7,20,9.23,20H9.4a4.69,4.69,0,0,1,4.16,2.51A8.27,8.27,0,0,1,14.71,22,6.15,6.15,0,0,0,10.18,18.8ZM7.76,17a2.59,2.59,0,0,1,0-3.51,2.25,2.25,0,0,1,1.61-.72h0a2.18,2.18,0,0,1,1.61.71,2.57,2.57,0,0,1,.7,1.76A2.53,2.53,0,0,1,11,17a2.18,2.18,0,0,1-1.61.71h0A2.2,2.2,0,0,1,7.76,17Z",
    transform: "translate(-2.74 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    fill: "none",
    d: "M28.81,15.21a2.56,2.56,0,0,1,.69-1.76,2.22,2.22,0,0,1,1.62-.71h0a2.27,2.27,0,0,1,1.62.72,2.59,2.59,0,0,1,0,3.51,2.22,2.22,0,0,1-1.62.71h0A2.22,2.22,0,0,1,29.49,17,2.57,2.57,0,0,1,28.81,15.21Z",
    transform: "translate(-2.74 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M31.94,18.8a3.44,3.44,0,0,0,1.68-1,3.8,3.8,0,0,0,1-2.6,3.74,3.74,0,0,0-1-2.6,3.43,3.43,0,0,0-2.5-1.11h0a3.45,3.45,0,0,0-2.51,1.09,3.82,3.82,0,0,0,0,5.21,3.4,3.4,0,0,0,1.7,1A6.18,6.18,0,0,0,25.77,22a7.91,7.91,0,0,1,1.16.49A4.68,4.68,0,0,1,31.09,20h.17c2.19,0,3.77,1.35,4.8,4.11l-7,0A8.22,8.22,0,0,1,30,25.31l7.78,0-.24-.8c-1.08-3.53-2.94-5.45-5.56-5.73m-.83-1.12A2.22,2.22,0,0,1,29.49,17a2.6,2.6,0,0,1,0-3.52,2.22,2.22,0,0,1,1.62-.71h0a2.27,2.27,0,0,1,1.62.72,2.59,2.59,0,0,1,0,3.51,2.22,2.22,0,0,1-1.62.71Z",
    transform: "translate(-2.74 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M19.71,21.61h0A5,5,0,0,0,23.41,20a5.59,5.59,0,0,0,1.49-3.83,5.33,5.33,0,0,0-5.19-5.43h0A5,5,0,0,0,16,12.35a5.55,5.55,0,0,0-1.5,3.83A5.33,5.33,0,0,0,19.71,21.61Zm-2.55-8.18A3.45,3.45,0,0,1,19.7,12.3h0a3.76,3.76,0,0,1,3.62,3.86,4,4,0,0,1-1.07,2.75A3.48,3.48,0,0,1,19.72,20h0a3.76,3.76,0,0,1-3.62-3.86A4,4,0,0,1,17.16,13.43Z",
    transform: "translate(-2.74 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M29.28,29A11,11,0,0,0,28,26.31a10,10,0,0,0-1.23-1.57,10.23,10.23,0,0,0-2.55-1.95,8.89,8.89,0,0,0-1.46-.62,9.37,9.37,0,0,0-3-.51h0a9.81,9.81,0,0,0-2.92.48,8.73,8.73,0,0,0-1.48.62,10.09,10.09,0,0,0-3.87,3.59A11,11,0,0,0,10.21,29l-.31,1L29.6,30Zm-17.19-.51a9,9,0,0,1,1.3-2.13,8.37,8.37,0,0,1,1.68-1.58,8,8,0,0,1,1-.62,8.75,8.75,0,0,1,1.46-.59,8.05,8.05,0,0,1,2.19-.32h0a7.81,7.81,0,0,1,2.32.35,8.74,8.74,0,0,1,1.45.61,9.29,9.29,0,0,1,.89.55,8.9,8.9,0,0,1,1.69,1.56,9,9,0,0,1,1.3,2.13Z",
    transform: "translate(-2.74 -10.73)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcon);
export default __webpack_public_path__ + "static/media/groups-icon.9fc2ccc06dc2dcdc9605b55473eae77f.svg";
export { ForwardRef as ReactComponent };